import { ingestData, ingestSponsorData } from "./intakeForm";

export const mapApiDataToReferenceData = (data) => {
  return {
    esg: ingestData(data, "ESG"),
    taxState: ingestData(data, "TaxState"),
    fundingSource: ingestData(data, "FundingSource"),
    statePreference: ingestData(data, "StatePreference"),
    yearsToTransition: ingestData(data, "YearsToTransition"),
  };
};

export const mapApiDataToSponsorDetails = (data) => {
  return {
    ...ingestSponsorData(data),
    strategyDetails: data,
  };
};
